/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Notifications_Team_Member_Added_HelpInputs */

const en_options_notifications_team_member_added_help = /** @type {(inputs: Options_Notifications_Team_Member_Added_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Receive an email notification any time a new team member is added to your team. This option applies to Team Admins only.`)
};

const fr_options_notifications_team_member_added_help = /** @type {(inputs: Options_Notifications_Team_Member_Added_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recevez un email lorsqu'un nouveau membre est ajouté à votre équipe. Cette option s'applique uniquement aux administrateurs d'équipe.`)
};

const de_options_notifications_team_member_added_help = /** @type {(inputs: Options_Notifications_Team_Member_Added_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie erhalten eine E-Mail-Benachrichtigung, sobald ein neues Teammitglied zu Ihrem Team hinzugefügt wird. Diese Option steht nur Team-Administratoren zur Verfügung.`)
};

const it_options_notifications_team_member_added_help = /** @type {(inputs: Options_Notifications_Team_Member_Added_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricevi una notifica via email ogni volta che un nuovo membro viene aggiunto al tuo team. Questa opzione è disponibile solo per gli amministratori del team.`)
};

const ru_options_notifications_team_member_added_help = /** @type {(inputs: Options_Notifications_Team_Member_Added_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получайте уведомления по электронной почте каждый раз, когда в вашу команду добавляется новый участник. Эта опция доступна только администраторам команды.`)
};

const es_options_notifications_team_member_added_help = /** @type {(inputs: Options_Notifications_Team_Member_Added_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reciba una notificación por correo electrónico cada vez que se añada un nuevo miembro a su equipo. Esta opción solo aplica a los administradores de equipo.`)
};

const zh_cn2_options_notifications_team_member_added_help = /** @type {(inputs: Options_Notifications_Team_Member_Added_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每当有新成员加入您的团队时，您都会收到电子邮件通知。此选项仅适用于团队管理员。`)
};

const ja_options_notifications_team_member_added_help = /** @type {(inputs: Options_Notifications_Team_Member_Added_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チームに新しいメンバーが追加されるたびにメール通知を受け取ります。このオプションはチーム管理者のみに適用されます。`)
};

const hi_options_notifications_team_member_added_help = /** @type {(inputs: Options_Notifications_Team_Member_Added_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जब भी आपकी टीम में कोई नया सदस्य जोड़ा जाए, तो आपको ईमेल द्वारा सूचना मिल जाएगी। यह विकल्प केवल टीम एडमिन के लिए उपलब्ध है।`)
};

const pt_pt2_options_notifications_team_member_added_help = /** @type {(inputs: Options_Notifications_Team_Member_Added_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Receba uma notificação por e-mail sempre que um novo membro for adicionado à sua equipe. Esta opção aplica-se apenas a administradores de equipe.`)
};

/**
* | output |
* | --- |
* | "Receive an email notification any time a new team member is added to your team. This option applies to Team Admins only." |
*
* @param {Options_Notifications_Team_Member_Added_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_notifications_team_member_added_help = /** @type {((inputs?: Options_Notifications_Team_Member_Added_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Notifications_Team_Member_Added_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_notifications_team_member_added_help(inputs)
	if (locale === "de") return de_options_notifications_team_member_added_help(inputs)
	if (locale === "it") return it_options_notifications_team_member_added_help(inputs)
	if (locale === "ru") return ru_options_notifications_team_member_added_help(inputs)
	if (locale === "es") return es_options_notifications_team_member_added_help(inputs)
	if (locale === "zh-CN") return zh_cn2_options_notifications_team_member_added_help(inputs)
	if (locale === "ja") return ja_options_notifications_team_member_added_help(inputs)
	if (locale === "hi") return hi_options_notifications_team_member_added_help(inputs)
	if (locale === "pt-PT") return pt_pt2_options_notifications_team_member_added_help(inputs)
	return en_options_notifications_team_member_added_help(inputs)
});